import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RegisterUserService } from '../../../services';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderCarouseTextComponent } from "./components";
import { AnimationOptions, LottieComponent } from 'ngx-lottie';

@Component({
  selector: 'app-loader-carousel',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    LottieComponent,
    LoaderCarouseTextComponent
  ],
  templateUrl: './loader-carousel.html',
  styleUrls: ['./loader-carousel.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderCarousel {
  private _registerUserService = inject(RegisterUserService);

  protected registerUser = this._registerUserService.registerUser;

  // Configuración de la animación Lottie del autobús
  public busAnimationOptions: AnimationOptions = {
    path: '/assets/animations/bus-route-animation.json',
    loop: true,
    autoplay: true
  };
}